import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import * as Tooltip from '@radix-ui/react-tooltip';
import { MainLayout } from './components/MainLayout';
import { ConfiguratorPage } from './components/configurator/ConfiguratorPage';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { SkipToContent } from './components/common/SkipToContent';

// Import workspace persistence to trigger auto-restore on app load
import './utils/workspacePersistence';

/**
 * Root application component
 * Uses React Router for page-based navigation:
 * - "/" renders the main editor (MainLayout)
 * - "/configurator" renders the full-page puppet configurator
 *
 * DndProvider wraps routes to enable drag-and-drop across all pages.
 * Tooltip.Provider is placed here at app level for optimal performance.
 * ErrorBoundary catches errors at the top level (Task 10.8)
 * SkipToContent provides accessibility skip link (Task 10.5)
 */
function App() {
  return (
    <ErrorBoundary>
      <SkipToContent />
      <BrowserRouter>
        <Tooltip.Provider delayDuration={300}>
          <DndProvider backend={HTML5Backend}>
            <Routes>
              <Route path="/" element={<MainLayout />} />
              <Route path="/configurator" element={<ConfiguratorPage />} />
            </Routes>
          </DndProvider>
        </Tooltip.Provider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
